<template>
  <div>
    <div
      v-if="successMessage"
      class="alert alert-success"
      style="color: rgb(5, 20, 48)"
    >
      {{ successMessage }}
    </div>

    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addOrder" v-if="show">
            <!-- Header -->
            <div
              style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;"
            >
              <h4
                style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;"
              >
                Walk-in Customer Order / Service
              </h4>
            </div>

            <div class="row">
              <!-- User -->
              <div class="col-md-4 col-12">
                <b-form-group label="User:" label-for="user_id">
                  <b-form-select
                    id="user_id"
                    v-model="user_id"
                    :state="validateField(user_id, 'number')"
                    :options="userOptions"
                  >
                    <option :value="null" disabled>-- Select User --</option>
                  </b-form-select>
                </b-form-group>
              </div>

              <!-- Product -->
              <div class="col-md-4 col-12">
                <b-form-group label="Product:" label-for="product_id">
                  <b-form-select
                    id="product_id"
                    :state="validateField(product_id, 'number')"
                    v-model="product_id"
                    :options="productOptions"
                  >
                    <option :value="null" disabled>-- Select Product --</option>
                  </b-form-select>
                </b-form-group>
              </div>

              <!-- Service Type -->
              <div class="col-md-4 col-12">
                <b-form-group label="Service Type:" label-for="service_type">
                  <b-form-input
                    id="service_type"
                    placeholder="Enter Service Type" :state="validateField(service_type)"
                    v-model="service_type"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Quantity -->
              <div class="col-md-4 col-12">
                <b-form-group label="Quantity:" label-for="quantity">
                  <b-form-input
                    id="quantity"
                    type="number"
                    min="1"
                    placeholder="Enter Quantity" :state="validateField(quantity)"
                    v-model="quantity"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Amount -->
              <div class="col-md-4 col-12">
                <b-form-group label="Amount:" label-for="amount">
                  <b-form-input
                    id="amount"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Enter Amount" :state="validateField(amount)"
                    v-model="amount"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Contact Person -->
              <div class="col-md-4 col-12">
                <b-form-group label="Contact Person:" label-for="contact_person">
                  <b-form-input
                    id="contact_person"
                    placeholder="Enter Contact Person" :state="validateField(contact_person)"
                    v-model="contact_person"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Contact Number -->
              <div class="col-md-4 col-12">
                <b-form-group label="Contact Number:" label-for="contact_number">
                  <b-form-input
                    id="contact_number"
                    placeholder="Enter Contact Number" :state="validateField(contact_number)"
                    v-model="contact_number"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Email -->
              <div class="col-md-4 col-12">
                <b-form-group label="Email:" label-for="email">
                  <b-form-input
                    id="email"
                    type="email"
                    placeholder="Enter Email" :state="validateField(email, 'email')"
                    v-model="email"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- Address -->
              <div class="col-md-4 col-12">
                <b-form-group label="Address:" label-for="address">
                  <b-form-input
                    id="address"
                    placeholder="Enter Address" :state="validateField(address)"
                    v-model="address"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-4 col-12">
                <b-form-group label="Apartment:" label-for="apartment">
                  <b-form-input
                    id="apartment"
                    placeholder="Enter Apartment" :state="validateField(apartment)"
                    v-model="apartment"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-4 col-12">
                <b-form-group label="Country:" label-for="country">
                  <b-form-input
                    id="country"
                    placeholder="Enter Country" :state="validateField(country)"
                    v-model="country"
                  ></b-form-input>
                </b-form-group>
              </div>
             
              <div class="col-md-4 col-12">
                <b-form-group label="Zip code:" label-for="zip_code">
                  <b-form-input
                    id="zip_code"
                    placeholder="Enter Zip Code" :state="validateField(zip_code)"
                    v-model="zip_code"
                  ></b-form-input>
                </b-form-group>
              </div>
             
              <div class="col-md-4 col-12">
                <b-form-group label="City:" label-for="city">
                  <b-form-input
                    id="city"
                    placeholder="Enter City" :state="validateField(city)"
                    v-model="city"
                  ></b-form-input>
                </b-form-group>
              </div>
             
              <div class="col-md-4 col-12">
                <b-form-group label="State:" label-for="state">
                  <b-form-input
                    id="state"
                    placeholder="Enter State" :state="validateField(state)"
                    v-model="state"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button
              type="submit"
              variant="primary"
              class="mb-8 mr-8"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      // Order fields
      user_id: null,
      product_id: null,
      userOptions: [],
      productOptions: [],
      quantity: "", // default empty
      amount: "",
      address: "",
      contact_person: "",
      contact_number: "",
      email: "",
      service_type: "",
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BSpinner,
  },
  mounted() {
    this.fetchUsers();
    this.fetchProducts();
  },
  methods: {
    validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
    },
    addOrder() {
      this.isLoading = true;

      axios
        .post("OrderManuallyStore", {
          user_id: this.user_id,
          product_id: this.product_id,
          quantity: this.quantity,
          amount: this.amount,
          address: this.address,
          contact_person: this.contact_person,
          contact_number: this.contact_number,
          email: this.email,
          service_type: this.service_type,
          state: this.state,
          apartment: this. apartment,
          country: this.country,
          city: this.city,
          zip_code: this.zip_code,
        })
        .then((response) => {
          this.$bvToast.toast("Order placed successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.successMessage = response.data.message;
          this.isLoading = false;

          // Reset form
          this.resetForm();
        })
        .catch((error) => {
          this.errorMessage =
            error.response?.data?.message || "Something went wrong!";
          this.$bvToast.toast(this.errorMessage, {
            title: "Error",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
        });
    },
    fetchUsers() {
      axios.get("/approvedAllUsersForExport").then((res) => {
        const users = res.data.data || [];
        this.userOptions = users.map((u) => ({
          value: u.id,
          text: `${u.first_name || ""} ${u.second_name || ""} ${u.last_name || ""}`.trim(),
        }));
      });
    },
    fetchProducts() {
      axios.get("/Productforexport").then((res) => {
        const products = res.data.data || [];
        this.productOptions = products.map((p) => ({
          value: p.id,
          text: p.name,
        }));
      });
    },
    resetForm() {
      this.user_id = null;
      this.product_id = null;
      this.quantity = "";
      this.amount = "";
      this.address = "";
      this.apartment = "";
      this.state = "";
      this.city = "";
      this.zip_code = "";
      this.country = "";
      this.contact_person = "";
      this.contact_number = "";
      this.email = "";
      this.service_type = "";
    },
  },
};
</script>
